<div *ngIf="isVisible" class="email-verification-bar flex items-center gap-3 bg-accent/20 border-b border-accent px-4 py-2 text-sm text-primary">
  <div class="flex flex-1 min-w-0 items-center gap-3 py-1">
    <mat-icon class="!text-lg !w-auto !h-auto shrink-0">mail_outline</mat-icon>
    <span class="font-medium truncate">
      <span class="sm:hidden">Verify your email</span>
      <span class="hidden sm:inline">Please verify your email address to secure your account.</span>
    </span>
  </div>

  <button
    type="button"
    (click)="resend()"
    [disabled]="isResending"
    class="shrink-0 font-medium underline whitespace-nowrap disabled:opacity-50"
  >
    {{ isResending ? 'Sending...' : 'Resend email' }}
  </button>
  <button
    type="button"
    class="shrink-0 font-medium underline whitespace-nowrap disabled:opacity-50"
    (click)="remindLater()"
    [disabled]="isSnoozing"
    aria-label="Remind me later"
  >
    <span class="sm:hidden">Later</span>
    <span class="hidden sm:inline">Remind me later</span>
  </button>
</div>
